export const shouldShowElement = ({
  device,
  showBannerMobile,
  showBannerDesktop,
}) => {
  if (device === 'desktop') {
    return showBannerDesktop
  }

  return device !== 'desktop' && showBannerMobile
}
